import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Spinner from "../../components/common/Spinner/Spinner";

export default function ProtectedRoute() {
  const { user, initializing, betaStatus } = useAuth();
  const location = useLocation();

  if (initializing) return <Spinner label="Checking your session..." />;

  // If user exists but beta is still being checked, hold the route (prevents dashboard flash)
  if (user && (betaStatus === "idle" || betaStatus === "checking")) {
    return <Spinner label="Verifying beta access…" />;
  }

  if (!user) {
    return (
      <Navigate
        to="/404"
        state={{ from: location, reason: "auth" }}
        replace
      />
    );
  }

  // If somehow blocked but still on a protected route, stall briefly until AuthContext logs out
  if (betaStatus === "blocked") {
    return <Spinner label="Verifying beta access…" />;
  }

  return <Outlet />;
}
